import type { MessageId } from './messages/en';
import { translate } from './translate';
import type { TranslateParams } from './types';

/** Translator for code outside React. Components can use `useT()`, which returns this same function. */
export function t(key: MessageId, params?: TranslateParams): string {
  return translate(key, params);
}
